@if (layoutService.isTabletDownView.value) {
  <div class="works-sp">
    <div class="create-work">
      <a class="spen-util-link" routerLink="/works/new" data-cy="transit-form">課題配信</a>
    </div>
    <div class="filter">
      <div class="box-info">
        <div class="row-info">
          <p class="label-input">検索条件</p>
          <p class="info-data" data-cy="text-filter">{{ filterService.messageFilter }}</p>
        </div>
        <div class="row-info">
          <p class="label-input">並び順</p>
          <p class="info-data" data-cy="text-sort-order">{{ messageSort }}</p>
        </div>
      </div>
      <div class="box-filter">
        <span class="btn-show-detail" (click)="changeShowFilterStatus()">
          <a class="spen-util-link">
            <span>変更</span>
            <i [ngClass]="isShowFilter ? 'fa fa-chevron-up' : 'fa fa-chevron-down'" data-cy="show-filter-status"></i>
          </a>
        </span>
        @if (isShowFilter) {
          <form [formGroup]="form">
            <div class="selector-group">
              <div class="form-group">
                <p class="label-input">権限</p>
                <label class="spen-mod-select">
                  <select class="select" formControlName="distributor" data-cy="distributor">
                    @for (distributor of distributorOptions; track $index) {
                      <option class="select-option" [ngValue]="distributor.formValue">
                        {{ distributor.text }}
                      </option>
                    }
                  </select>
                  <i class="fa fa-caret-down"></i>
                </label>
              </div>
              <div class="form-group">
                <p class="label-input">配信課題名</p>
                <input
                  class="spen-mod-input-text"
                  data-cy="search-title"
                  placeholder="配信課題名を入力してください"
                  maxlength="50"
                  formControlName="keyword"
                />
              </div>
              <div class="form-group">
                <p class="label-input">並び順</p>
                <label class="spen-mod-select">
                  <select
                    class="select"
                    formControlName="sort_value"
                    data-cy="sort-order"
                    (change)="onChangeSortValue($event.target.value)"
                  >
                    <option class="select-option" value="配信日時（降順）">配信日時（降順）</option>
                    <option class="select-option" value="配信日時（昇順）">配信日時（昇順）</option>
                  </select>
                  <i class="fa fa-caret-down"></i>
                </label>
              </div>
            </div>
            <div class="button-group">
              <button
                type="button"
                class="spen-mod-btn is-primary"
                data-cy="submit-filter"
                (click)="onSubmitFilter()"
                [disabled]="isLoadingData()"
              >
                適用する
              </button>
              <button
                type="button"
                class="cancel spen-mod-btn is-default"
                data-cy="remove-filter"
                [disabled]="isLoadingData() || isDefaultForm()"
                (click)="removeFilter()"
              >
                選択解除
              </button>
            </div>
          </form>
        }
      </div>
    </div>
    @if (contentLoaded) {
      @if (delivery_works.length > 0) {
        <div class="list-submission">
          <p class="paginate-info" data-cy="text-page-info">{{ page() | paginateText }}</p>
          @for (work of delivery_works; track work.id; let last = $last) {
            <div class="list-item clickable-item" [class.last]="last" data-cy="delivered-work-item" (click)="onClickWork(work.id)">
              <div class="info">
                <div class="work-name">
                  @if (isScheduled(work.delivered_at)) {
                    <span class="delivery-label" data-cy="is-scheduled">予約中</span>
                  }
                  <span class="truncate-text"
                    ><b data-cy="work-title">{{ work.title }}</b></span
                  >
                </div>
                <p class="truncate-text creator-name" data-cy="creator-name">配信者：{{ work.create_user_name }}</p>
                <p class="text-smaller" data-cy="answer-count">
                  提出数：{{ work.answers_count | number }}/{{ work.deliveries_count | number }}
                </p>
                <p class="text-smaller delivered-time" data-cy="delivered-at">配信日時：{{ work.delivered_at }}</p>
                <div class="text-smaller space-name">
                  <span class="truncate-text" data-cy="space-name">配信先：{{ work.spaces[0].name }}</span>
                  @if (work.spaces.length > 1) {
                    <span class="more-space" data-cy="space-count">他{{ work.spaces.length - 1 | number }}件</span>
                  }
                </div>
              </div>
              <i class="fa fa-chevron-right"></i>
            </div>
          }
          @if (showPagination) {
            <div class="spen-mod-paginate pagination-custom">
              <spen-paginator [length]="page().total_pages" [pageIndex]="page().current_page - 1" (page)="pageChanged($event)" />
            </div>
          }
        </div>
      } @else {
        <div class="empty-message">
          {{ isSearching ? '検索結果が0件です。' : 'ここに校内で配信された課題が表示されます。' }}
        </div>
      }
    } @else {
      <div class="spen-mod-flex-loading">
        <div class="loading-icon"></div>
      </div>
    }
  </div>
} @else {
  <div class="works-pc">
    <div class="create-work">
      <a routerLink="/works/new" class="spen-mod-btn create-button" data-cy="transit-form">課題配信</a>
    </div>
    <form [formGroup]="form" class="filter-form">
      <div class="form-contents">
        <div class="form-group">
          <span class="label">権限</span>
          @for (distributorOption of distributorOptions; track $index) {
            <label class="spen-mod-radio creator-label-item" data-cy="distributor">
              <input
                class="radio"
                formControlName="distributor"
                data-cy="distributor-value"
                [value]="distributorOption.formValue"
                type="radio"
              />
              <i class="fa"></i><span class="text" data-cy="distributor-name">{{ distributorOption.text }}</span>
            </label>
          }
        </div>
        <div class="form-group">
          <span class="label">配信課題名</span>
          <input
            type="text"
            class="spen-mod-input-text"
            placeholder="配信課題名を入力してください"
            maxlength="50"
            formControlName="keyword"
            data-cy="search-title"
          />
        </div>
      </div>
      <div class="button-group">
        <button
          type="button"
          class="spen-mod-btn is-default"
          data-cy="remove-filter"
          (click)="removeFilter()"
          [disabled]="isLoadingData() || isDefaultForm()"
        >
          選択解除
        </button>
        <button
          type="button"
          class="spen-mod-btn is-primary"
          data-cy="submit-filter"
          (click)="onSubmitFilter()"
          [disabled]="isLoadingData()"
        >
          検索する
        </button>
      </div>
    </form>
    @if (contentLoaded) {
      <div class="data-info">
        @if (isSearching || delivery_works.length > 0) {
          <p class="filter-info" data-cy="text-filter">検索条件：{{ filterService.messageFilter }}</p>
        }
        @if (!inProgressSort && delivery_works.length > 0) {
          <p class="page-info" data-cy="text-page-info">{{ page() | paginateText }}</p>
        }
      </div>
    }
    <div class="content">
      @if (contentLoaded) {
        @if (delivery_works.length > 0) {
          <div class="list-submission">
            <div class="spen-mod-flex-table table-list-full has-link">
              <div class="flex-table-head">
                <div class="flex-item col-size-4 is-first-col">配信課題名</div>
                <div class="flex-item col-size-3">配信者</div>
                <div class="flex-item col-size-3">
                  <a class="spen-util-link" (click)="changeBySortColumn('delivered_at')"
                    >配信日時
                    <i [class]="sortStatus['delivered_at']" data-cy="col-sort-icon"></i>
                  </a>
                </div>
                <div class="flex-item col-size-4">配信先</div>
                <div class="flex-item col-size-2 pull-right">提出数</div>
                <div class="flex-item redirect-cell"></div>
              </div>
              @for (work of delivery_works; track work.id) {
                <a class="flex-table-row clickable-item" data-cy="delivered-work-item" (click)="onClickWork(work.id)">
                  <div class="flex-item col-size-4 is-first-col truncate-text">
                    <div class="work-title">
                      @if (isScheduled(work.delivered_at)) {
                        <span class="delivery-label" data-cy="is-scheduled">予約中</span>
                      }
                      <span class="truncate-text" data-cy="work-title">{{ work.title }}</span>
                    </div>
                  </div>
                  <div class="flex-item col-size-3 truncate-text" data-cy="creator-name">{{ work.create_user_name }}</div>
                  <div class="flex-item col-size-3" data-cy="delivered-at">{{ work.delivered_at }}</div>
                  <div class="flex-item col-size-4 space-name">
                    <a class="spen-util-link truncate-text" data-cy="space-name" (click)="onClickSpaceName(work.spaces[0].id)">
                      {{ work.spaces[0].name }}
                    </a>
                    @if (work.spaces.length > 1) {
                      <span data-cy="space-count">他{{ work.spaces.length - 1 | number }}件</span>
                    }
                  </div>
                  <div class="flex-item col-size-2 pull-right" data-cy="answer-count">
                    {{ work.answers_count | number }}/{{ work.deliveries_count | number }}
                  </div>
                  <div class="flex-item redirect-cell is-icon-item">
                    <i class="fa fa-chevron-right"></i>
                  </div>
                </a>
              }
            </div>
            @if (showPagination) {
              <div class="spen-mod-paginate pagination-custom">
                <spen-paginator [length]="page().total_pages" [pageIndex]="page().current_page - 1" (page)="pageChanged($event)" />
              </div>
            }
          </div>
        } @else {
          <div class="empty-message">
            {{ isSearching ? '検索結果が0件です。' : 'ここに校内で配信された課題が表示されます。' }}
          </div>
        }
      } @else {
        <div class="spen-mod-flex-loading">
          <div class="loading-icon"></div>
        </div>
      }
    </div>
  </div>
}
